import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function HowItWorks() {
  const days = [{
    day: 'Día 1',
    title: 'Limpieza del Sistema',
    desc: 'Implementas el Reset Lumínico y la Regla del Límite de las 2 PM para limpiar tu sistema y el de tu bebé.'
  }, {
    day: 'Día 2',
    title: 'Consolidación Nocturna',
    desc: 'Aplicas las Ventanas de Presión de Sueño para asegurar que la primera fase de la noche sea ininterrumpida.'
  }, {
    day: 'Día 3',
    title: 'Rescate y Rutina',
    desc: 'Ejecutas la Intervención Gentil de 5 minutos y comienzas tu lunes con el Plan de Rescate de Oficina.'
  }];
  return <div className="bg-navy text-cream" data-id="element-112">
      <SectionWrapper data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-16 text-white" data-id="element-115">
            El Protocolo de <span className="text-gold italic" data-id="element-116">72 Horas</span>
          </h2>

          <div className="relative" data-id="element-117">
            {/* Vertical Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-px bg-gold/20" data-id="element-118"></div>

            <div className="space-y-12 md:space-y-24" data-id="element-119">
              {days.map((item, index) => <div key={index} className={`relative flex flex-col md:flex-row items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-120">
                  {/* Timeline Dot */}
                  <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-12 h-12 bg-navy border-4 border-gold rounded-full items-center justify-center z-10 text-gold font-bold font-serif" data-id="element-121">
                    {index + 1}
                  </div>

                  {/* Content Box */}
                  <div className={`w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-16' : 'md:pr-16'}`} data-id="element-122">
                    <div className="bg-navy-light p-8 rounded-sm border border-gold/10 relative" data-id="element-123">
                      <div className="md:hidden absolute -top-4 left-8 bg-gold text-navy px-4 py-1 rounded-full font-bold text-sm" data-id="element-124">
                        {item.day}
                      </div>
                      <div className="hidden md:block text-gold font-bold tracking-widest uppercase text-sm mb-2" data-id="element-125">
                        {item.day}
                      </div>
                      <h3 className="text-2xl font-serif text-white mb-4 mt-4 md:mt-0" data-id="element-126">
                        {item.title}
                      </h3>
                      <p className="text-cream/70 font-sans leading-relaxed" data-id="element-127">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}